import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getChickenEvents(params, signal) {
  return request({
    url: '/chickenEvent/chickenEvents',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function getChickenEventNames() {
  return request({
    url: '/dictionaries/chickenEventName',
    method: 'get',
  });
}

export function getExelExport(params) {
  return request({
    url: '/chickenEvent/chickenEvents/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}
